import Axios from 'axios'
import Config from '../../../../config'
import {
    GetTeams,
    ReportTypeName,
    CourseSelected,
    GetCourseStats,
    GetCourseStatsTotals,
    PulsesAttendanceStats,
    ActiveUsersStats,
    HelpRequestsStats,
    FeedbackStats,
    InstitutionsStats,
} from './api-dashboard.types'

const baseURL = `${process.env.REACT_APP_REPORTS}`.trim()

export const ApiDashboard = Axios.create({
    baseURL,
})

export const getTeams = (userID: string, limit = 100) =>
    Axios.get<GetTeams['data']>(`${Config.API}/profile/${userID}/teams?limit=${limit}`).then(({ data }) =>
        data.professorSchedules.filter(({ course }) => course.isVisible).map(({ course }) => course)
    )

export const getFastReports = (
    courseID: string,
    reportName: ReportTypeName,
    from: string,
    to: string,
    institution: string
) =>
    Axios.get(
        `${Config.API}/v3/course/${courseID}/fastReports?reportName=${reportName}&startDate=${from}&endDate=${to}&institution=${institution}`
    ).then(({ data }) => data)

export const getCourseStats = ({ courseId, elements, from, to }: CourseSelected) =>
    ApiDashboard.get<GetCourseStats>('/dash/allstudentsinfo', {
        params: {
            courseId,
            from,
            to,
            fullInfo: true,
            elements,
        },
    }).then(({ data }) => data[courseId])

export const getCourseStatsTotals = ({ courseId, from, to }: CourseSelected) =>
    ApiDashboard.get<GetCourseStatsTotals>('/course/courseInfoByDates', {
        params: {
            courseId,
            to,
            from,
        },
    }).then(({ data }) => data[courseId])

export const downloadReports = (url: string, fileName: string) =>
    ApiDashboard.get(url, {
        responseType: 'blob',
        baseURL: '/',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        return new Blob([response.data])
    })

export const getReportsDashboardPulsesAttendance = (courseId: string, from: string, to: string, institution: string) =>
    ApiDashboard.get<PulsesAttendanceStats>(`course/attendance-and-pulses`, {
        params: {
            courseId,
            from,
            to,
            institution,
        },
    }).then(({ data }) => data)

export const getReportsDashboardActiveUsers = (courseId: string, from: string, to: string, institution: string) =>
    ApiDashboard.get<ActiveUsersStats>(`course/active-users`, {
        params: {
            courseId,
            from,
            to,
            institution,
        },
    }).then(({ data }) => data)

export const getReportsDashboardHelpRequests = (courseId: string, from: string, to: string, institution: string) =>
    ApiDashboard.get<HelpRequestsStats>(`help-request/by-course`, {
        params: {
            courseId,
            from,
            to,
            institution,
        },
    }).then(({ data }) => data)

export const getReportsDashboardFeedback = (courseId: string, from: string, to: string, institution: string) =>
    ApiDashboard.get<FeedbackStats>(`feedback/by-course`, {
        params: {
            courseId,
            from,
            to,
            institution,
        },
    }).then(({ data }) => data)

export const getReportsDashboardInstitutions = (courseId: string) =>
    ApiDashboard.get<InstitutionsStats[]>(`course/institutions`, {
        params: {
            courseId,
        },
    }).then(({ data }) => data)

export const fastReportsAsynchronous = (courseId: string, reportName: string, from: string, to: string) =>
    Axios.get(`${Config.API}/v3/course/${courseId}/fastReports`, {
        params: {
            reportName,
            from,
            to,
        },
    }).then((data) => data)
